var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCalendarDays = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  stroke: "#021854",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  className: "calendar-days_svg__lucide calendar-days_svg__lucide-calendar-days"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 2v4M16 2v4"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  x: 3,
  y: 4,
  rx: 2
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M3 10h18M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01M16 18h.01"
})));
export { SvgCalendarDays as ReactComponent };
export default __webpack_public_path__ + "c41c230753b9032d4490352b21750e5a.svg";